import { useReducer, useEffect, useState } from "react";
import { projectFirestore, timestamp } from "../Firebase/Config";

let initialState = {
    document: null,
    isPending: false,
    error: null,
    success: null
}

// reducer
const firestoreReducer = (state, action) => {
    switch(action.type){
        case 'IS_PENDING':
            return { isPending: true, document: null, success: false, error: null }
        case 'ADDED_DOCUMENT':
            return {isPending: false, document: action.payload, success: true, error: null }
        case 'ERROR':
            return {isPending: false, document: null, success: false, error: action.payload }
        case 'DELETED_DOCUMENT':
            return {isPending: false, document: null, success: true, error: null }
        case 'UPDATED_DOCUMENT':
            return {isPending: false, document: action.payload, success: true, error: null }
        default:
            return state
    }
} 

export const useFireStore = (collection) => {
    const [response, dispatch] = useReducer(firestoreReducer, initialState);
    const [isCancelled, setIsCancelled ] = useState(false)
    
    // collection reference
    const reference = projectFirestore.collection(collection);

    // only dispatch if not cancelled 
    const dispatchIfNotCancelled = (action) => {
        if(!isCancelled){
            dispatch(action)
        }
    }

    // add document
    const addDocument = async(doc) => {
        dispatch({ type: 'IS_PENDING' })
        try{
            const createdAt = timestamp.fromDate(new Date())
            const addedDocumnet = await reference.add({...doc, createdAt})
            dispatchIfNotCancelled({ type: 'ADDED_DOCUMENT', payload: addedDocumnet })
        }catch (err) {
            dispatchIfNotCancelled({ type: 'ERROR', payload: err.message })
        }
    }

    // delete document
    const deleteDocument = async (id) => {
        dispatch({ type: 'IS_PENDING'})
        try {
            await reference.doc(id).delete();
            dispatchIfNotCancelled({ type: 'DELETED_DOCUMENT'})
        }catch(err){
            dispatchIfNotCancelled({ type: 'ERROR', payload: err.message })
        }
    }

    // update document
    const updateDocument = async (id, updates) => {
        dispatch({ type: 'IS_PENDING'})
        try {
            const updatedDocument = await reference.doc(id).update(updates)
            dispatchIfNotCancelled({ type: 'UPDATED_DOCUMENT', payload: updatedDocument})
            return updatedDocument
        } catch (error) {
            dispatch({ type: 'ERROR', payload: error.message})
            return null
        }
    }

    useEffect(() => {
        return () => setIsCancelled(true)
    }, [])

    return { addDocument, deleteDocument, updateDocument, response }
}